<template>
  <div class="tipBanner">
    <div class="main-width tipBanner__content">
      <div class="tipBanner__btn" @click='handleCooperate'>我要合作</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "SettleTipFooterBanner",

  computed: {
    auth() {
      return this.$auth.$state;
    },
  },
  methods: {
    handleCooperate() {
      if (this.auth.loggedIn) {
        this.$router.push("/settled/process");
      } else {
        this.$store.commit('setVisibleRegisterModal', true);
      }
    },
  },
};
</script>
<style lang="scss" scoped>

.tipBanner {
  position: fixed;
  z-index: 99;
  width: 100%;
  min-width: 1200px;
  left: 0;
  bottom: 0;
  height: 114px;
  background: linear-gradient(90deg, #6f5ff4 0%, #5b78fe 49%, #6e61f5 100%);
  &__content {
    position: relative;
    height: 100%;
    &::before {
      content: "";
      position: absolute;
      width: 492px;
      height: 153px;
      background: url("~assets/img/customer/customer_footer_tip.png") no-repeat
        center;
      bottom: 0;
      left: 180px;
    }
  }
  &__btn {
    width: 228px;
    height: 60px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 200px;
    color: #212529;
    font-size: 28px;
    font-weight: 600;
    text-align: center;
    line-height: 60px;
    border-radius: 30px;
    user-select: none;
    cursor: pointer;
    background: linear-gradient(180deg, #fffd00 0%, #ffbe00 100%);
    &:hover {
      background: linear-gradient(180deg, #ffd400 0%, #ff8a00 100%);
    }
  }
}

</style>